import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CommonEffects } from './+state/common.effects';
import { Http401Interceptor } from './interceptors/http401.interceptor';
import * as fromCommon from './+state/common.reducer';
import { AppInitService } from './services/app-init.service';
import { ConfigService } from './services/config.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ClipboardModule } from 'ngx-clipboard';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromCommon.CONFIGURATION_FEATURE_KEY,
      fromCommon.reducer
    ),
    EffectsModule.forFeature([CommonEffects]),
    ClipboardModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (appInitService: AppInitService) => () =>
        appInitService.init(),
      deps: [AppInitService, ConfigService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Http401Interceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
  declarations: [
    NotFoundComponent,
    NotAuthorizedComponent
  ],
})
export class BackOfficeCommonModule {}
